import React from 'react'
import cn from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'

const style = {
  root: {
    width: '25px',
    height: '20px',
  },
}

const PolygonIconActive = ({ classes, className, ...props }) => (
  <SvgIcon
    {...props}
    className={cn(classes.root, className)}
    fill="none"
    viewBox="0 0 25 20"
  >
    <svg fill="none">
      <path
        d="M2.72745 4.5621L23.2693 2.54905L20.8949 17.4478L6.66746 14.4022L2.72745 4.5621Z"
        fill="white"
        stroke="#004360"
      />
      <path
        d="M24.4867 2.09766C24.4867 2.70517 23.9942 3.19766 23.3867 3.19766C22.7792 3.19766 22.2867 2.70517 22.2867 2.09766C22.2867 1.49014 22.7792 0.997656 23.3867 0.997656C23.9942 0.997656 24.4867 1.49014 24.4867 2.09766Z"
        fill="white"
        stroke="#004360"
        stroke-width="0.8"
      />
      <path
        d="M7.38906 14.7979C7.38906 15.4054 6.89658 15.8979 6.28906 15.8979C5.68155 15.8979 5.18906 15.4054 5.18906 14.7979C5.18906 14.1903 5.68155 13.6979 6.28906 13.6979C6.89658 13.6979 7.38906 14.1903 7.38906 14.7979Z"
        fill="white"
        stroke="#004360"
        stroke-width="0.8"
      />
      <path
        d="M3.58828 4.29785C3.58828 4.90536 3.09579 5.39785 2.48828 5.39785C1.88077 5.39785 1.38828 4.90536 1.38828 4.29785C1.38828 3.69034 1.88077 3.19785 2.48828 3.19785C3.09579 3.19785 3.58828 3.69034 3.58828 4.29785Z"
        fill="white"
        stroke="#004360"
        stroke-width="0.8"
      />
      <path
        d="M22.0883 17.7979C22.0883 18.4054 21.5958 18.8979 20.9883 18.8979C20.3808 18.8979 19.8883 18.4054 19.8883 17.7979C19.8883 17.1903 20.3808 16.6979 20.9883 16.6979C21.5958 16.6979 22.0883 17.1903 22.0883 17.7979Z"
        fill="white"
        stroke="#004360"
        stroke-width="0.8"
      />
    </svg>
  </SvgIcon>
)

export default withStyles(style)(PolygonIconActive)
